import {gql} from '@apollo/client';
import {ATR_FRAGMENT, STAFF} from '../../graphql/fragments';

export const LATEST_ATR = gql`
  ${ATR_FRAGMENT}
  ${STAFF}
  query LatestAtr($contactId: UUID!, $accountId: UUID!) {
    latestAtr(contactId: $contactId) {
      ...AtrFragment
    }
    advisers(accountId: $accountId) {
      ...Staff
    }
    getCurrentUser {
      ...Staff
    }
  }
`;

export const REQUEST_ATR = gql`
  ${ATR_FRAGMENT}
  mutation RequestAtr($contactId: UUID!, $staffId: UUID!, $accountId: UUID!) {
    requestAtr(contactId: $contactId, staffId: $staffId, accountId: $accountId) {
      ok
      errors
      atr {
        ...AtrFragment
      }
      contactId
    }
  }
`;

export const UPDATE_ATR = gql`
  ${ATR_FRAGMENT}
  mutation UpdateAtr($atrId: UUID!, $amendedValue: Int, $amendReason: String) {
    updateAtr(atrId: $atrId, amendedValue: $amendedValue, amendReason: $amendReason) {
      ok
      errors
      atr {
        ...AtrFragment
      }
    }
  }
`;

export const SUBMIT_ATR = gql`
  ${ATR_FRAGMENT}
  mutation SubmitAtr($atrId: UUID!) {
    submitAtr(atrId: $atrId) {
      ok
      errors
      atr {
        ...AtrFragment
      }
      errors
    }
  }
`;
